import styled from 'styled-components';

export const DropDownContainer = styled.div`
  top: 30px;
  box-shadow: 0px 3px 8px var(--overlay);

  & > div {
    padding: 16px 0 16px 16px;
  }
`;

export const FilterDropdownButton = styled.div`
  align-items: center;

  && > i {
    color: var(--luft-secondary);
  }
`;

export const ButtonTitleContainer = styled.div`
  flex: 1;

  > span {
    color: var(--luft-primary);
    font-weight: bold;
  }

  > i {
    color: var(--luft-primary);
  }
`;

export const ClearFilters = styled.div`
  display: flex;
  align-items: center;

  && > span {
    font-style: italic;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    color: var(--luft-secondary);
    margin-right: 4px;
  }
  && > i {
    color: var(--luft-secondary);
  }

  &:hover {
    opacity: 0.8;
  }
`;
